import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { BasicModalV2, TextButton } from '../../../../components/index.js';
import CustomModalHeader from '../../../Common/customComponents/CustomModalHeader.tsx';

import { useAsync } from '../../../../hooks/index.js';
import CustomText from 'containers/Common/customComponents/CustomText.tsx';
import CustomTable from 'containers/Common/customComponents/CustomTable.tsx';
import { ptwApi } from '../../../../api/ptw.api.ts';

interface IProps {
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  isModalOpen: boolean;
  title: string;
  columnHeaderLabel?: string;
  categorySeq?: number;
  onActionCallback: any;
}

const PermitIssueTypeModal = (props: IProps) => {
  const { columnHeaderLabel = 'JHA No' } = props;
  const { callAsync, showAlarm, closeAlarm } = useAsync();
  const [searchData, setSearchData] = useState<any>({});

  /*테이블관련*/
  const [gridData, setGridData] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [tableSort, setTableSort] = useState<any>({});
  const [pageSize, setPageSize] = useState<number>(10);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [checkedList, setCheckedList] = useState<any>([]);
  const handleChange = (e: any) => {
    setSearchData((oData: any) => {
      return { ...oData, [e.target.name]: e.target.value };
    });
  };

  useEffect(() => {
    if (props.isModalOpen) {
      search(1);
    }
  }, [props.isModalOpen, searchData]);

  useEffect(() => {
    if (props.isModalOpen) {
      search(currentPage);
    }
  }, [currentPage, tableSort.sortColumn, tableSort.sortValue, pageSize]);

  const search = (pageNum?: number) => {
    const param = {
      ...searchData,
      page: pageNum,
      size: pageSize,
      ...(props.categorySeq ? { categorySeq: props.categorySeq } : {}),
      ...(tableSort?.sortColumn && tableSort?.sortValue
        ? { sort: `${tableSort.sortColumn},${tableSort.sortValue}` }
        : {})
    };

    ptwApi.getJhaList(param).then(function (r) {
      const resultList = r.resultList.map((row: any, index: number) => ({
        ...row,
        no: index + 1 + (currentPage - 1) * pageSize
      }));

      setGridData(resultList);
      setTotalCount(r.resultList[0]?.totalCount);
    });
  };
  const modalClose = () => {
    props.setIsModalOpen(false);
  };
  const columns = [
    {
      column: 'no',
      label: 'No',
      align: 'center',
      size: 50
    },
    {
      column: 'jhaNo',
      label: columnHeaderLabel,
      align: 'center',
      sort: true,
      size: 150
    },
    {
      column: 'fileName',
      label: 'File name',
      align: 'center',
      size: 300
    }
  ];

  return (
    <BasicModalV2 open={props.isModalOpen} onClose={() => props.setIsModalOpen(false)}>
      <CustomModalHeader title={props.title} modalClose={modalClose} />
      <div className={'custom-modal-body'} style={{ width: '800px', height: '620px' }}>
        <div className={'contents-box'}>
          <div className={'search-box'}>
            <div className={'search-item-list'}>
              <div className={'search-item'}>
                <CustomText
                  onChange={handleChange}
                  name={'jhaNo'}
                  value={searchData?.jhaNo}
                  isBtnClose
                  isBtnSearch
                />
              </div>
            </div>
          </div>

          <div className={'grid-box'}>
            <CustomTable
              columns={columns}
              data={gridData}
              setData={setGridData}
              isPaging={true}
              isCheck={false}
              pageSize={pageSize}
              setPageSize={setPageSize}
              totalCount={totalCount}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setTableSort={setTableSort}
              className={'min-w-100'}
              setSelectedRow={setSelectedRow}
              setCheckedList={setCheckedList}
              dbClick={() => {
                props.onActionCallback(selectedRow);
              }}
            />
          </div>
        </div>
      </div>
    </BasicModalV2>
  );
};

export default PermitIssueTypeModal;
